import PropTypes from 'prop-types';
import React from 'react';
import ReportBox from './reportBox';
import count from './count';

const TotalServiceSales = ({ report, shortCount, showGiftCards }) => {
  let data = [{
    title: 'Squire',
    amount: report.paidViaSquireAmount,
    count: count(report.paidViaSquireCount, shortCount),
    tooltip: 'Includes no shows that have not been cancelled. Does not include cancellations.',
  }, {
    title: 'In-Shop POS',
    amount: report.paidInShopViaPosAmount,
    count: count(report.paidInShopViaPosCount, shortCount),
    tooltip: 'Does not include cancellations or no shows.',
  }, {
    title: 'In-Shop Cash',
    amount: report.paidInShopOtherAmount,
    count: count(report.paidInShopOtherCount, shortCount),
    tooltip: 'Does not include cancellations or no shows.',
  }, {
    title: 'Gift Card',
    amount: report.paidViaGiftCardAmount,
    count: count(report.paidViaGiftCardCount, shortCount),
  }, {
    title: 'Net Total',
    amount: report.totalAmount,
    count: count(report.totalCount, shortCount),
    tooltip: 'No shows booked through Squire that have not been cancelled or rescheduled are also included.',
  }, {
    title: 'Discounts/Promos/Loyalty',
    amount: report.totalDiscount,
    count: count(report.discountCount, shortCount),
  }, {
    title: 'Total',
    amount: report.totalAmount + report.totalDiscount,
    count: count(report.totalCount, shortCount),
  }];

  if (!showGiftCards) {
    data = data.filter(({ title }) => title !== 'Gift Card');
  }

  const content = data.map((item, index) => (
    <ReportBox key={index} {...item} />
  ));

  return (
    <div className="layout u-mv-">{content}</div>
  );
};

TotalServiceSales.propTypes = {
  report: PropTypes.object.isRequired,
  shortCount: PropTypes.bool,
  showGiftCards: PropTypes.bool.isRequired,
};

TotalServiceSales.defaultProps = {
  shortCount: false,
};

export default TotalServiceSales;
